// extracted by mini-css-extract-plugin
export default {"content":"style_content__3mJp2","leftSide":"style_leftSide__whtwg","rightSide":"style_rightSide__ggESO","type":"style_type__Dkybb"};